import { useMemo } from 'react';
import { useQueries } from '@tanstack/react-query';
import { IMMIGRATION_SNAPSHOTS } from '../constants/queryKeys';
import { getImmigrationSnapshots } from 'src/shared/services/fn-api/Immigration';
import { IImmigrationSnapshot } from 'src/shared/types/Immigration';

export const useGetImmigrationSnapshots = (beneId: number, countries: string[]) => {
  const queries = useQueries({
    queries:
      countries.map((countryCode) => ({
        queryKey: [IMMIGRATION_SNAPSHOTS, beneId, countryCode],
        queryFn: () => getImmigrationSnapshots({ beneId: beneId.toString(), countryCode }),
        enabled: !!beneId && countries.length > 0,
      })) ?? [],
  });

  const isFetched = queries.some((query) => query.isFetched);
  const allDataLoaded = countries.length > 0 && queries.every((query) => query.isFetched && query.data);

  const immigrationSnapshots = useMemo(() => {
    if (!allDataLoaded) return null;

    return queries.reduce((acc, query, index) => {
      acc[countries[index]] = query.data as IImmigrationSnapshot[];
      return acc;
    }, {} as Record<string, IImmigrationSnapshot[]>);
  }, [allDataLoaded]);

  return { isFetched, immigrationSnapshots };
};
